import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Classes,
  Alignment,
  Popover,
  Navbar,
  Button,
  Menu,
  MenuDivider,
} from '@blueprintjs/core';
import Premium from '../Assets/Images/Premium.jpg';
import Seal from '../Assets/Images/Seal.gif';
import SroFilterMenu from './SroFilterMenu';

class Header extends React.Component {
  render() {
    return (
      <div>
        <Navbar className="bp3-dark">
          <div className="container">
            <Navbar.Group
              align={Alignment.CENTER}
              style={{ justifyContent: 'space-between' }}
            >
              <Navbar.Heading style={{ width: '25%' }}>
                <NavLink to="/" className="SroFilterLogo">
                  <img
                    src={Seal}
                    alt="SRO Filter"
                    className="mr-2"
                    style={{ background: `url('${Premium}')` }}
                  />
                  SROFILTER
                </NavLink>
              </Navbar.Heading>
              <NavLink to="/" className="bp3-button bp3-minimal bp3-icon-home">
                Home
              </NavLink>
              <NavLink
                to="/Payments"
                className="bp3-button bp3-minimal bp3-icon-credit-card"
              >
                Payments
              </NavLink>
              <NavLink
                to="/GodMode"
                className="bp3-button bp3-minimal bp3-icon-map"
              >
                God Mode
              </NavLink>
              <NavLink
                to="/Players"
                className="bp3-button bp3-minimal bp3-icon-geosearch"
              >
                Players
              </NavLink>
              <NavLink
                to="/Guilds"
                className="bp3-button bp3-minimal bp3-icon-search-around"
              >
                Guilds
              </NavLink>
              <NavLink
                to="/Logs"
                className="bp3-button bp3-minimal bp3-icon-history"
              >
                Logs
              </NavLink>
              <Navbar.Divider />
              <Popover
                content={
                  <Menu className={Classes.ELEVATION_1}>
                    <MenuDivider className="mb-2" title="[GM] Nozich" />

                    <MenuDivider className="mt-1" />

                    <NavLink
                      to="/Profile"
                      className="bp3-menu-item bp3-icon-mugshot"
                    >
                      Change Profile
                    </NavLink>

                    <NavLink
                      to="/Profile/ChangePassword"
                      className="bp3-menu-item bp3-icon-key"
                    >
                      Change Password
                    </NavLink>

                    <MenuDivider />

                    <a
                      href="https://srofilter.com/logout.jsp"
                      className="bp3-menu-item bp3-icon-log-out"
                    >
                      Logout
                    </a>
                  </Menu>
                }
              >
                <Button minimal icon="user" />
              </Popover>
              <Popover
                content={
                  <table className="bp3-html-table bp3-html-table-bordered bp3-html-table-condensed bp3-html-table-striped bp3-interactive bp3-small">
                    <thead>
                      <tr>
                        <th style={{ minWidth: '270px' }}>Notification</th>
                        <th>Datetime</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>Sass, TypeScript, React</td>
                        <td>12:36 AM</td>
                      </tr>

                      <tr>
                        <td>TypeScript</td>
                        <td>12:36 AM</td>
                      </tr>

                      <tr>
                        <td>SVG, TypeScript, D3</td>
                        <td>12:36 AM</td>
                      </tr>
                    </tbody>
                  </table>
                }
              >
                <Button minimal icon="notifications" />
              </Popover>

              <SroFilterMenu />
            </Navbar.Group>
          </div>
        </Navbar>
      </div>
    );
  }
}

export default Header;
